import React, { useState, useEffect } from 'react'
import { useStore, useDispatch } from 'react-redux'
import Select, { components } from 'react-select'
import CreatableSelect from 'react-select/creatable';
import { ReactComponent as CheckSvg } from '../../assets/svg/check_new.svg'
import { setSpendDuration, updateDataSource } from '../../redux/actions/app'
import { uploadData } from '../../redux/actions/upload'
import { matchUploadedData, parseFullAddress, setParsedFullAddress } from '../../redux/actions/upload'
import { toast } from '../CommonComponents/ToastComponent/toast'
import ToggleButton from '../CommonComponents/ToggleButton'
import SpendInfoModal from './modal/spend-modal'
import { getAllCustomerNames, getAllMasterSuppliersData, getCustomerNames } from '../../redux/actions/vendor'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import NotParsedAddressTable from './not-parsed-address-table'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { Loader } from 'rsuite';
import { checkIsAdmin, checkIsAdminOrModerator } from '../../services/helper'
import { getPartnerNames } from '../../redux/actions/partner'
import ThreeStateToggleButton from '../CommonComponents/ThreeStateToggleButton'
import ModalComponent from '../CommonComponents/Modal'
import { getCallerScriptsOfPartner } from '../../redux/actions/caller';
import { bulkUpdateChildColumnsValues, bulkUpdateMasterColumnsValues } from '../../utils/constants/reportFilters';
import { validationFields } from '../../utils/constants/reportFilters'

const MatchComponent = ({ onGoBack, onContinue, dbMatchColumns, dbMatchDataValues, onChangeDbMatchValues, onEmailFocusOut, onKeyDown, onPhoneInputChange, onPhoneNumberFocusOut, phoneInputRefname, isValidatingPhone, isPhoneValid, isValidatingEmail, isEmailValid, isTest = false, onShowPartnerManagement, onShowCreateCallingScript, setDbmatchValues, setSelectedSupplierType, setSelectedSupplierOption, selectedSupplierOption, onCallWithStatus }) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    vendor: { allMasterSuppliers },
    upload: { uploadedData, matchedData, isFullAddressParsed },
    app: { uploadAllVendorColumns, dataSources, currentDataSource, spendTimeFrame, spendTimeType, notParsedAddressColumns },
    domain: {
      currentDomain,
    },
    partner: { partnerNames },
    auth: { user }
  } = store

  const CustomOption = (props) => {
    if (props.data.header) {
      return (
        <components.Option {...props} >
          <div className='d-flex justify-content-between font-weight-bold' >
            <span >Company Name</span>
            <span>List ID</span>
          </div>
        </components.Option>
      );
    } else {
      // Render option
      return (
        <components.Option {...props}>
          <div className='d-flex justify-content-between'>
            <span>{props.data.label}</span>
            <span>{props.data.listId}</span>
          </div>
        </components.Option>
      );
    }
  };

  useEffect(() => {
    dispatch(getAllMasterSuppliersData())
    dispatch(getPartnerNames()).then(res => {
      if (dbMatchDataValues?.partnerName) {
        let callingScripts = res.find(partner => partner?.partnerName === dbMatchDataValues?.partnerName)?.callingScripts
        if (callingScripts?.length > 0) {
          setCallingScriptsList(callingScripts)
        } else {
          setCallingScriptsList([])
        }
      }
    })

    dispatch(getCallerScriptsOfPartner()).then((res) => {
      setAllCallingScriptsList(res)
    }).catch(err => {
      toast.show({
        title: 'Warning',
        description: 'Unable To Get All Scripts',
      })
    })

    dispatch(getAllCustomerNames()).then((res) => {
      let tmp = []
      res.forEach(element => {
        tmp.push({ label: element?.companyName, value: element?.id, name: element?.companyName, listId: element?.id, primaryContact: element?.primaryContact, contactEmail: element?.contactEmail, contactPhone: element?.contactPhone, nameUse: element?.nameUse, callingScriptId: element?.callingScriptId })
      });
      setCompanyList(tmp)
    }).catch((err) => {
      toast.show({
        title: 'Warning',
        description: 'Unable To Get Company List',
      })
    })
    setUpdateSupplierType(selectedSupplierOption)
  }, [])

  const isAdminOrModerator = checkIsAdminOrModerator(currentDomain)
  const isAdmin = checkIsAdmin(currentDomain)
  const [showHeader, setShowHeader] = useState(true)
  const [colWithStatus, setColWithStatus] = useState([])
  const [isParsingFullAddress, setIsParsingFullAddress] = useState(false)
  const [showNonParsedAddress, setShowNonParsedAddress] = useState(false)
  const [notParsedAddressData, setNotParsedAddressData] = useState([])
  const [importedNotParsedAddressData, setImportedNotParsedAddressData] = useState([])
  const [showManualParsedAddress, setShowManualParsedAddress] = useState(false)
  const [primaryContactsList, setPrimaryContactsList] = useState([])
  const [callingScriptsList, setCallingScriptsList] = useState([])
  const [allCallingScriptsList, setAllCallingScriptsList] = useState([])
  const [companyList, setCompanyList] = useState([])
  const [companyName, setCompanyName] = useState({ label: '', value: null, name: '', listId: '', primaryContact: '', contactEmail: '', contactPhone: '', useName: '', callingScriptId: '' })
  const [modal, setModal] = useState(false)
  const [backdrop, setBackdrop] = React.useState('static');
  const [zIndex, setZindex] = useState({
    partnerName: 0,
    companyName: 0
  })
  const [showModal, setShowModal] = useState(false)
  const [updateSupplierType, setUpdateSupplierType] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const addressColumns = ['address1', 'address2', 'city', 'state', 'zip', 'country']
  const cardVariableFeeCols = ['isAcceptAmexVariableFee', 'isAcceptVisaVariableFee', 'isAcceptMasterCardVariableFee']
  const cardMinPaymentColumns = ['americanExpressMinPaymnet', 'visaMinPayment', 'mastercardMinPayment']
  const cardMaxPaymentColumns = ['americanExpressMaxPayment', 'visaMaxPayment', 'mastercardMaxPayment']
  const cardIncrementalPaymentColumns = ['amexIncrementalPaymentAmount', 'visaIncrementalPaymentAmount', 'mastercardIncrementalPaymentAmount']
  const cardProcessingFeeCols = ['amexProcessingDollarFeeValue', 'amexProcessingPercentFeeValue', 'visaProcessingDollarFeeValue', 'visaProcessingPercentFeeValue', 'mastercardProcessingDollarFeeValue', 'mastercardProcessingPercentFeeValue']
  const cardMinFeeCols = ['amexDollarMinPaymentFeeValue', 'amexPercentMinPaymentFeeValue', 'visaDollarMinPaymentFeeValue', 'visaPercentMinPaymentFeeValue', 'mastercardDollarMinPaymentFeeValue', 'mastercardPercentMinPaymentFeeValue']
  const cardMaxFeeCols = ['amexDollarMaxPaymentFeeValue', 'amexPercentMaxPaymentFeeValue', 'visaDollarMaxPaymentFeeValue', 'visaPercentMaxPaymentFeeValue', 'mastercardDollarMaxPaymentFeeValue', 'mastercardPercentMaxPaymentFeeValue']
  const cardIncrementalFeeCols = ['amexDollarIncrementalPaymentFeeValue', 'amexPercentIncrementalPaymentFeeValue', 'visaDollarIncrementalPaymentFeeValue', 'visaPercentIncrementalPaymentFeeValue', 'mastercardDollarIncrementalPaymentFeeValue', 'mastercardPercentIncrementalPaymentFeeValue']
  const cardGenericProcessingFeeMatchCols = ['genericDollarProcessingFee', 'genericPercentProcessingFee', 'generic dollar fee', 'generic $ fee', 'generic dollar processing fee', 'genericdollarfee', 'genericdollarprocessingfee', 'generic percent fee', 'generic % fee', 'generic percent processing fee', 'genericpercentfee', 'genericpercentprocessingfee']
  const cardGenericMinFeeMatchCols = ['genericDollarMinFee', 'genericPercentMinFee', 'generic dollar min fee', 'generic $ min fee', 'generic dollar minimum fee', 'genericdollarminfee', 'genericdollarminimumfee', 'generic percent min fee', 'generic % min fee', 'generic percent minimum fee', 'genericpercentminfee', 'genericpercentminimumfee']
  const cardGenericMaxFeeMatchCols = ['genericDollarMaxFee', 'genericPercentMaxFee', 'generic dollar max fee', 'generic $ max fee', 'generic dollar maximum fee', 'genericdollarmaxfee', 'genericdollarmaximumfee', 'generic percent max fee', 'generic % max fee', 'generic percent maximum fee', 'genericpercentmaxfee', 'genericpercentmaximumfee']
  const cardGenericIncrementalFeeMatchCols = ['genericDollarIncrementalFee', 'genericPercentIncrementalFee', 'generic dollar incremental fee', 'generic $ incremental fee', 'genericdollarincrementalfee', 'generic percent incremental fee', 'generic % incremental fee', 'genericpercentincrementalfee']
  const cardGenericMinPaymentMatchCols = ['genericMinPayment', 'Generic Min payment', 'Generic Minimum payment', 'Minimum Payment', 'Min Payment', 'MinPayment', 'MinimumPayment', 'GenericMinimumPayment', 'GenericMinPayment']
  const cardGenericMaxPaymentMatchCols = ['genericMaxPayment', 'Generic Max payment', 'Generic Maximum payment', 'Maximum Payment', 'Max Payment', 'MaxPayment', 'MaximumPayment', 'GenericMaximumPayment', 'GenericMaxPayment']
  const cardGenericIncPaymentMatchCols = ['genericIncrementalPayment', 'Generic Incremental payment', 'Generic Inc payment', 'Incremental Payment', 'Inc Payment', 'IncPayment', 'IncrementalPayment', 'GenericIncrementalPayment', 'GenericIncPayment']
  const [uploadFileType, setUploadFileType] = useState('')
  const [supplierType, setSupplierType] = useState('')

  const columnOptions = currentDataSource ? [
    ...uploadAllVendorColumns && uploadAllVendorColumns.filter(vendorColumn =>
      currentDataSource.columns.includes(vendorColumn.name) && !vendorColumn.ignore
    ).map(col => (
      {
        label: col.label,
        value: col.name,
      }
    ))] : []

  // vendor columns is matched or unmatched
  const matchedStatus = uploadAllVendorColumns.map(vendorColumn => ({
    ...vendorColumn,
    isMatched: false,
  }))

  const dataSourceOptions = dataSources && dataSources.map(dataSource => {
    return {
      label: dataSource.label,
      value: dataSource.name,
      columns: dataSource.columns,
    }
  })

  // add bulk update option if current user is admin or has sub role bulk update
  if (isAdmin || user?.isBulkUpdate) {
    dataSourceOptions.push(
      {
        value: 'bulkUpdate',
        label: 'Bulk Update',
        columns: []
      })
  }

  const handleClickConfirm = (col) => {
    if (col.confirm === 2) {
      return
    }
    if (!col.matchedName) {
      toast.show({
        title: 'Warning',
        description: 'Please select column to be matched!',
      })
      return
    }
    if (col.matchedName === 'masterId') {
      let isExistMasterID = []
      uploadedData.data.map((row) => {
        allMasterSuppliers.map(item => {
          if (row[col.originalName] === item.id)
            isExistMasterID.push(true)
        })
      })
      if (isExistMasterID.indexOf(false) !== -1 || isExistMasterID.length === 0) {
        toast.show({
          title: 'Warning',
          description: "Master ID doesn't exist",
        })
        return
      }
    }
    // if user matched uploaded column to spend
    if (col.matchedName === 'spend') {
      handleShowModal()
    }
    let tmpCols = [...colWithStatus]
    tmpCols = tmpCols.map(tmpCol => {
      if (tmpCol.originalName === col.originalName) {
        return {
          originalName: col.originalName,
          matchedName: tmpCol.matchedName,
          confirm: 2,
        }
      }
      if (tmpCol.matchedName === col.matchedName) {
        return {
          originalName: tmpCol.originalName,
          matchedName: '',
          confirm: tmpCol.confirm,
        }
      }
      return tmpCol
    })
    setColWithStatus(tmpCols)
    onCallWithStatus(tmpCols)
  }


  const onHandleOpenModal = () => {
    setModal(true)
  }

  const onHandleCloseModal = () => {
    setModal(false)
  }
  // click ignore button
  const handleClickIgnore = (col) => {
    if (col.matchedName === 'fullAddress') {
      dispatch(setParsedFullAddress(false))
    }
    let tmpCols = [...colWithStatus]
    tmpCols = tmpCols.map(tmpCol => {
      if (tmpCol.originalName === col.originalName) {
        return {
          originalName: col.originalName,
          matchedName: col.matchedName,
          // matchedName: null,
          confirm: 0,
        }
      }
      return tmpCol
    })
    setColWithStatus(tmpCols)
    onCallWithStatus(tmpCols)
  }


  // click continue button
  const handleClickContinue = async () => {
    let notParsedAddressesArray = [] //[...notParsedAddressData]
    if (currentDataSource?.value === "list") {
      if (!dbMatchDataValues?.companyName) {
        toast.show({
          title: 'Warning',
          description: 'Company name shouldn\'t be empty!',
        })
        return
      }
      if (!dbMatchDataValues?.partnerName) {
        toast.show({
          title: 'Warning',
          description: 'Partner name shouldn\'t be empty!',
        })
        return
      }
      if (isValidatingPhone) {
        toast.show({
          title: 'Warning',
          description: 'validating phone number...!',
        })
        return
      }
      if (isValidatingEmail) {
        toast.show({
          title: 'Warning',
          description: 'validating email...!',
        })
        return
      }
      if (!isEmailValid && isEmailValid !== '') {
        toast.show({
          title: 'Warning',
          description: 'Invalid Email'
        })
        return
      }
      if (isPhoneValid === false) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Phone Number.'
        })
        return
      }
    }

    if (!currentDataSource) {
      toast.show({
        title: 'Warning',
        description: 'You should select data source.',
      })
      return
    }

    // if there is spend
    if (colWithStatus.findIndex(col => col.matchedName === 'spend' && col.confirm === 2) !== -1) {
      if (!spendTimeType || spendTimeType === '' || !spendTimeFrame) {
        setShowModal(true)
        return
      }
    }

    setIsLoading(true)
    let isFullAddMapped = colWithStatus.find((column) => column.matchedName === 'fullAddress')
    let uploadedDataObject = { ...uploadedData }

    // start parse Full Address if it is mapped
    if (!showManualParsedAddress && isFullAddMapped && isFullAddMapped.confirm === 2) {
      addressColumns.map((addColumn) => {
        let isColumn = colWithStatus.find((column) => column.matchedName === addColumn)
        if (!isColumn) {
          let colName = addColumn[0].toUpperCase() + addColumn.substring(1)
          uploadedDataObject.cols.push(colName)
          uploadedDataObject.data.map((row) => {
            row[colName] = ''
          })
        }
      })

      if (!isFullAddressParsed) {
        for (let index = 0; index < uploadedData.data.length; index++) {
          const row = uploadedData.data[index];
          setIsParsingFullAddress(true);

          // If the row has the address value
          if (row[isFullAddMapped.originalName] && row[isFullAddMapped.originalName] !== '') {
            try {
              const addResult = await dispatch(parseFullAddress(row[isFullAddMapped.originalName]));
              let add1 = '';
              let add2 = '';

              // Build Address Line 1
              addResult.result.find((data) => { if (data.tag === 'AddressNumberPrefix') { add1 += data.value; } });
              addResult.result.find((data) => { if (data.tag === 'AddressNumber') { add1 += !add1 ? data.value : ' ' + data.value; } });
              addResult.result.find((data) => { if (data.tag === 'AddressNumberSuffix') { add1 += !add1 ? data.value : ' ' + data.value; } });
              addResult.result.find((data) => { if (data.tag === 'StreetNamePreDirectional') { add1 += !add1 ? data.value : ' ' + data.value; } });
              addResult.result.find((data) => { if (data.tag === 'StreetName') { add1 += !add1 ? data.value : ' ' + data.value; } });
              addResult.result.find((data) => { if (data.tag === 'StreetNamePostType') { add1 += !add1 ? data.value : ' ' + data.value; } });
              addResult.result.find((data) => { if (data.tag === 'StreetNamePostDirectional') { add1 += !add1 ? data.value : ' ' + data.value; } });
              addResult.result.find((data) => { if (data.tag === "USPSBoxType") { add1 += !add1 ? data.value : ' ' + data.value; } });
              addResult.result.find((data) => { if (data.tag === "USPSBoxID") { add1 += !add1 ? data.value : ' ' + data.value; } });

              // Build Address Line 2
              addResult.result.find((data) => { if (data.tag === 'SubaddressType') { add2 += data.value; } });
              addResult.result.find((data) => { if (data.tag === 'SubaddressIdentifier') { add2 += !add2 ? data.value : ' ' + data.value; } });
              addResult.result.find((data) => { if (data.tag === 'OccupancyType') { add2 += !add2 ? data.value : ' ' + data.value; } });
              addResult.result.find((data) => { if (data.tag === 'OccupancyIdentifier') { add2 += !add2 ? data.value : ' ' + data.value; } });

              let city = addResult.result.find((data) => data.tag === 'PlaceName');
              let state = addResult.result.find((data) => data.tag === 'StateName');
              let country = addResult.result.find((data) => data.tag === 'CountryName');
              let zip = addResult.result.find((data) => data.tag === 'ZipCode');

              await setAddresColumnsValues(row, colWithStatus, add1, add2, city, state, country, zip);

            } catch (err) {
              // If the address couldn't be parsed
              await setAddresColumnsValues(row, colWithStatus);
              const tmpRow = { ...row };
              delete uploadedData.data[index];

              // Finding column names and assigning empty strings to address fields
              let Address1 = colWithStatus.find((column) => column.matchedName === 'address1') ? colWithStatus.find((column) => column.matchedName === 'address1').originalName : 'address1';
              let Address2 = colWithStatus.find((column) => column.matchedName === 'address2') ? colWithStatus.find((column) => column.matchedName === 'address2').originalName : 'address2';
              let City = colWithStatus.find((column) => column.matchedName === 'city') ? colWithStatus.find((column) => column.matchedName === 'city').originalName : 'city';
              let State = colWithStatus.find((column) => column.matchedName === 'state') ? colWithStatus.find((column) => column.matchedName === 'state').originalName : 'state';
              let Country = colWithStatus.find((column) => column.matchedName === 'country') ? colWithStatus.find((column) => column.matchedName === 'country').originalName : 'country';
              let Zip = colWithStatus.find((column) => column.matchedName === 'zip') ? colWithStatus.find((column) => column.matchedName === 'zip').originalName : 'zip';

              tmpRow[[Address1]] = '';
              tmpRow[[Address2]] = '';
              tmpRow[[City]] = '';
              tmpRow[[State]] = '';
              tmpRow[[Zip]] = '';
              tmpRow[[Country]] = '';
              tmpRow.id = index;
              tmpRow.changed = false;
              tmpRow.edited = false;
              tmpRow['Full address that can not be parsed'] = row[isFullAddMapped.originalName];
              notParsedAddressesArray.push(tmpRow);

              // Change not parsed address table columns
              for (let i = 1; i <= 6; i++) {
                let value = i === 1 ? Address1 : i === 2 ? Address2 : i === 3 ? City : i === 4 ? State : i === 5 ? Zip : Country;
                notParsedAddressColumns[i] = {
                  ...notParsedAddressColumns[i],
                  name: value,
                  label: value
                };
              }
            }
          } else {
            // If there's no address to parse
            await setAddresColumnsValues(row, colWithStatus);
          }
        }
      }


      // set that all full addresses parsed
      setIsParsingFullAddress(false)
      dispatch(setParsedFullAddress(true))

      addressColumns.map((addColumn) => {
        let isColumn = colWithStatus.find((column) => column.matchedName === addColumn)
        if (!isColumn) {
          let colName = addColumn[0].toUpperCase() + addColumn.substring(1)
          colWithStatus.push({ originalName: colName, matchedName: addColumn, confirm: 1 })
        }
      })
      colWithStatus.map((col) => {
        if (addressColumns.includes(col.matchedName)) {
          col.confirm = 2 // set address columns mapped value true
        }
      })
    }

    dispatch(
      matchUploadedData(colWithStatus)
    )

    if (notParsedAddressesArray.length === 0 || showManualParsedAddress) {
      isTest ? onContinue('settings') : onContinue('preview')
    } else {
      uploadedData.data = uploadedData.data.filter(data => data);
      setNotParsedAddressData(notParsedAddressesArray)
      setShowNonParsedAddress(true)
    }
    
    setIsLoading(false)
  }

  // change matched column
  const handleChangeRealCol = (val, data) => {
    let tmpCols = [...colWithStatus]
    tmpCols = tmpCols.map(tmpCol => {
      if (tmpCol.originalName === data.originalName) {
        return {
          originalName: data.originalName,
          matchedName: val.value,
          confirm: tmpCol.confirm === 0 ? 1 : tmpCol.confirm,
        }
      }
      return tmpCol
    })
    setColWithStatus(tmpCols)
    onCallWithStatus(tmpCols)
  }

  // get suggested value with original name from vendor columns
  const getSuggestedValueFromOriginalName = (originalName) => {
    if (!uploadAllVendorColumns || uploadAllVendorColumns?.length === 0) {
      return null
    }
    const matchedName = uploadAllVendorColumns?.find(vendorColumn => {
      const matchedColumn = matchedStatus?.find(matched => matched?.name === vendorColumn?.name)
      const isMatched = matchedColumn && matchedColumn?.isMatched
      if (isMatched) {
        return false
      }
      if (vendorColumn?.suggest) {
        if (!vendorColumn?.aryMatches || vendorColumn?.aryMatches?.length === 0) {
          if (originalName?.toLowerCase()?.includes(vendorColumn?.name?.toLowerCase())) {
            matchedStatus.find(matched => matched.name === vendorColumn.name)['isMatched'] = true
            return true
          }
        } else if (vendorColumn?.aryMatches?.findIndex(match => originalName?.toLowerCase()?.includes(match?.toLowerCase())) !== -1) {
          matchedStatus.find(matched => matched.name === vendorColumn.name)['isMatched'] = true
          return true
        }
      }
      return false
    })
    return matchedName ? matchedName?.name : null
  }

  // get value for select to select matched column
  const getSuggestedSelectValue = (col) => {
    const currentColWithStatus = colWithStatus.find(colWith => colWith.originalName === col.originalName)

    // if there are multi matched columns, set others matched name except first to null
    const allMatchedCol = colWithStatus.filter(colWith => colWith.matchedName === col.matchedName && col.confirm === 2 && col.originalName !== colWith.originalName)
    if (allMatchedCol.length > 1) {
      allMatchedCol.map((item, index) => {
        if (index !== 0) {
          item.matchedName = null
        }
        return null
      })
      return null
    }
    // if it's ignored column, return null
    if (currentColWithStatus.confirm === 0) {
      return null
    }

    const currentColumnOption = columnOptions?.find(item => item.value === col.matchedName && col.originalName !== item.originalName)
    if (!currentColumnOption) {
      return null
    }
    return currentColumnOption
  }

  const handleChangeDataSource = (dataSource) => {
    setUploadFileType(dataSource?.value || '')
    if (dataSource?.value === 'bulkUpdate') {
      const tempUploadedData = [...uploadedData?.data];

      const hasPlaceholder = (value) => {
        const placeholders = ["#", "string", "example@gmail.com", "true/false"];
        return placeholders.some(placeholder => String(value).includes(placeholder));
      };
      const shouldRemoveFirstElement = Object.values(tempUploadedData[0]).some(hasPlaceholder);
      if (shouldRemoveFirstElement) {
        tempUploadedData.shift();
      }
      dispatch(
        uploadData({
          cols: uploadedData?.cols,
          data: tempUploadedData,
          fileName: uploadedData?.fileName,
          processedRows: uploadedData?.processedRows,
          totalRows: uploadedData?.totalRows
        })
      )
    }
    dispatch(
      updateDataSource(dataSource)
    )
  }

  function ExcelDateToJSDate(serial) {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);
    var fractional_day = serial - Math.floor(serial) + 0.0000001;
    var total_seconds = Math.floor(86400 * fractional_day);
    var seconds = total_seconds % 60;
    total_seconds -= seconds;
    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;
    return `${date_info.getUTCFullYear()}/${date_info.getUTCMonth() + 1}/${date_info.getUTCDate()}`
  }

  const watchCell = (matchName, cell) => {
    if (matchName === "contactDate") {
      return ExcelDateToJSDate(cell)
    }
  }

  const matchContents = () => {
    if (!colWithStatus || colWithStatus.length === 0) {
      return null
    }
    if (!currentDataSource) {
      return
    }
    let tableData = !showManualParsedAddress ? uploadedData.data : importedNotParsedAddressData //notParsedAddressData

    const listCols = ['partnerSupplierId', 'accountNumber']
    return (
      <div className="match-content">
        {
          colWithStatus && colWithStatus.length > 0 && colWithStatus.map((col, index) => {
            if (currentDataSource?.value !== 'list' && listCols?.includes(col.matchedName)) {
              return
            }
            if ((col.matchedName === 'autoCreateMaster' || col.originalName.toLowerCase() === 'auto create master' || col.originalName === 'autoCreateMaster' || col.originalName.toLowerCase() === 'create master' || col.originalName === 'CreateMaster') && ((currentDomain?.roleId !== 3 && currentDomain?.roleName !== 'admin' && currentDomain?.roleId !== 2 && currentDomain?.roleName !== 'moderator') || currentDataSource?.value === 'list')) {
              return
            }

            if ((col.matchedName === 'cardPaymentByPhoneValue' || col.originalName.toLowerCase() === 'card acceptance phone' || col.originalName.toLowerCase() === 'card phone' || col.originalName === 'cardPaymentByPhoneValue')) {
              let confirmVal = colWithStatus.find(colwith => colwith.matchedName === "isAcceptCardPaymentByPhone")
              if (!confirmVal || confirmVal.confirm !== 2) {
                return
              }
            }

            if ((col.matchedName === 'cardPaymentByFaxValue' || col.originalName.toLowerCase() === 'card acceptance fax' || col.originalName.toLowerCase() === 'card fax' || col.originalName === 'cardPaymentByFaxValue')) {
              let confirmVal = colWithStatus.find(colwith => colwith.matchedName === "isAcceptCardPaymentByFax")
              if (!confirmVal || confirmVal.confirm !== 2) {
                return
              }
            }

            if ((col.matchedName === 'cardEmail' || col.originalName.toLowerCase() === 'card acceptance email' || col.originalName.toLowerCase() === 'card email' || col.originalName === 'cardEmail')) {
              let confirmVal = colWithStatus.find(colwith => colwith.matchedName === "isAcceptCardPaymentByEmail")
              if (!confirmVal || confirmVal.confirm !== 2) {
                return
              }
            }

            if (!showManualParsedAddress && (addressColumns.includes(col.matchedName) || addressColumns.includes(col.originalName.toLowerCase()))) { // remove address columns if full address is mapped
              let isFullAddMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'fullAddress')
              if (isFullAddMatched.length > 0) {
                return
              }
            }

            if (!showManualParsedAddress && (col.matchedName === 'fullAddress' || col.originalName.toLowerCase() === 'full address')) { // remove full address column if any of address column is mapped
              let matchedAddressColumns = colWithStatus.filter((column) => column.confirm === 2 && (addressColumns.includes(column.matchedName) || addressColumns.includes(column.originalName.toLowerCase())))
              if (matchedAddressColumns.length > 0) {
                return
              }
            } else if (showManualParsedAddress && (col.matchedName === 'fullAddress' || col.originalName.toLowerCase() === 'full address')) {
              return
            }

            if (col.matchedName === 'isAcceptVariableFee' || col.originalName === 'isAcceptVariableFee' || col.originalName.toLowerCase() === 'generic variable fee' || col.originalName.toLowerCase() === 'genericvariablefee' || col.originalName.toLowerCase() === 'accepts generic variable fee') { // remove generic variable fee column if any of card specific variable fee column is mapped
              let matchedCardVariableFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && (cardVariableFeeCols.includes(column.matchedName) || cardVariableFeeCols.includes(column.originalName.toLowerCase())))
              if (matchedCardVariableFeeColumns.length > 0) {
                return
              }
            }

            if (cardVariableFeeCols.includes(col.matchedName) || cardVariableFeeCols.includes(col.originalName.toLowerCase())) { // remove card specific variable fee columns if card generic variable fee column is mapped
              let isGenericVariableFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'isAcceptVariableFee')
              if (isGenericVariableFeeMatched.length > 0) {
                return
              }
            }

            if (cardGenericProcessingFeeMatchCols.includes(col.matchedName) || cardGenericProcessingFeeMatchCols.includes(col.originalName) || cardGenericProcessingFeeMatchCols.includes(col.originalName.toLowerCase())) { // remove generic processing fee column if any of card specific processing fee column is mapped
              let matchedCardProcessingFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && (cardProcessingFeeCols.includes(column.matchedName) || cardProcessingFeeCols.includes(column.originalName.toLowerCase())))
              if (matchedCardProcessingFeeColumns.length > 0) {
                return
              }
            }

            if (cardProcessingFeeCols.includes(col.matchedName) || cardProcessingFeeCols.includes(col.originalName.toLowerCase())) { // remove card specific processing fee columns if card generic processing fee column is mapped
              let isGenericProcessingFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && (column.matchedName === 'genericDollarProcessingFee' || column.matchedName === 'genericPercentProcessingFee'))
              if (isGenericProcessingFeeMatched.length > 0) {
                return
              }
            }

            if (cardGenericMinFeeMatchCols.includes(col.matchedName) || cardGenericMinFeeMatchCols.includes(col.originalName) || cardGenericMinFeeMatchCols.includes(col.originalName.toLowerCase())) { // remove generic min fee columns if any of card specific min fee column is mapped
              let matchedCardMinFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && (cardMinFeeCols.includes(column.matchedName) || cardMinFeeCols.includes(column.originalName.toLowerCase())))
              if (matchedCardMinFeeColumns.length > 0) {
                return
              }
            }

            if (cardMinFeeCols.includes(col.matchedName) || cardMinFeeCols.includes(col.originalName.toLowerCase())) { // remove card specific min fee columns if card generic min fee column is mapped
              let isGenericMinFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && (column.matchedName === 'genericDollarMinFee' || column.matchedName === 'genericPercentMinFee'))
              if (isGenericMinFeeMatched.length > 0) {
                return
              }
            }

            if (cardGenericMaxFeeMatchCols.includes(col.matchedName) || cardGenericMaxFeeMatchCols.includes(col.originalName) || cardGenericMaxFeeMatchCols.includes(col.originalName.toLowerCase())) { // remove generic max fee columns if any of card specific max fee column is mapped
              let matchedCardMaxFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && (cardMaxFeeCols.includes(column.matchedName) || cardMaxFeeCols.includes(column.originalName.toLowerCase())))
              if (matchedCardMaxFeeColumns.length > 0) {
                return
              }
            }

            if (cardMaxFeeCols.includes(col.matchedName) || cardMaxFeeCols.includes(col.originalName.toLowerCase())) { // remove card specific max fee columns if card generic max fee column is mapped
              let isGenericMaxFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && (column.matchedName === 'genericDollarMaxFee' || column.matchedName === 'genericPercentMaxFee'))
              if (isGenericMaxFeeMatched.length > 0) {
                return
              }
            }

            if (cardGenericIncrementalFeeMatchCols.includes(col.matchedName) || cardGenericIncrementalFeeMatchCols.includes(col.originalName) || cardGenericIncrementalFeeMatchCols.includes(col.originalName.toLowerCase())) { // remove generic incremental fee columns if any of card specific incremental fee column is mapped
              let matchedCardIncrementalFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && (cardIncrementalFeeCols.includes(column.matchedName) || cardIncrementalFeeCols.includes(column.originalName.toLowerCase())))
              if (matchedCardIncrementalFeeColumns.length > 0) {
                return
              }
            }

            if (cardIncrementalFeeCols.includes(col.matchedName) || cardIncrementalFeeCols.includes(col.originalName.toLowerCase())) { // remove card specific incremental fee columns if card generic incremental fee column is mapped
              let isGenericIncrementalFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && (column.matchedName === 'genericDollarIncrementalFee' || column.matchedName === 'genericPercentIncrementalFee'))
              if (isGenericIncrementalFeeMatched.length > 0) {
                return
              }
            }

            if (cardGenericMinPaymentMatchCols.includes(col.matchedName) || cardGenericMinPaymentMatchCols.includes(col.originalName) || cardGenericMinPaymentMatchCols.includes(col.originalName.toLowerCase())) { // remove generic min payment column if any of card specific min payment column is mapped
              let matchedCardMinPaymentColumns = colWithStatus.filter((column) => column.confirm === 2 && (cardMinPaymentColumns.includes(column.matchedName) || cardMinPaymentColumns.includes(column.originalName.toLowerCase())))
              if (matchedCardMinPaymentColumns.length > 0) {
                return
              }
            }

            if (cardMinPaymentColumns.includes(col.matchedName) || cardMinPaymentColumns.includes(col.originalName.toLowerCase())) { // remove card specific min payment columns if card generic min payment column is mapped
              let isGenericMinPaymentMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'genericMinPayment')
              if (isGenericMinPaymentMatched.length > 0) {
                return
              }
            }

            if (cardGenericMaxPaymentMatchCols.includes(col.matchedName) || cardGenericMaxPaymentMatchCols.includes(col.originalName) || cardGenericMaxPaymentMatchCols.includes(col.originalName.toLowerCase())) { // remove generic max payment column if any of card specific max payment column is mapped
              let matchedCardMaxPaymentColumns = colWithStatus.filter((column) => column.confirm === 2 && (cardMaxPaymentColumns.includes(column.matchedName) || cardMaxPaymentColumns.includes(column.originalName.toLowerCase())))
              if (matchedCardMaxPaymentColumns.length > 0) {
                return
              }
            }

            if (cardMaxPaymentColumns.includes(col.matchedName) || cardMaxPaymentColumns.includes(col.originalName.toLowerCase())) { // remove card specific max payment columns if card generic max payment column is mapped
              let isGenericMaxPaymentMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'genericMaxPayment')
              if (isGenericMaxPaymentMatched.length > 0) {
                return
              }
            }

            if (cardGenericIncPaymentMatchCols.includes(col.matchedName) || cardGenericIncPaymentMatchCols.includes(col.originalName) || cardGenericIncPaymentMatchCols.includes(col.originalName.toLowerCase())) { // remove generic incremental payment column if any of card specific incremental payment column is mapped
              let matchedCardIncPaymentColumns = colWithStatus.filter((column) => column.confirm === 2 && (cardIncrementalPaymentColumns.includes(column.matchedName) || cardIncrementalPaymentColumns.includes(column.originalName.toLowerCase())))
              if (matchedCardIncPaymentColumns.length > 0) {
                return
              }
            }

            if (cardIncrementalPaymentColumns.includes(col.matchedName) || cardIncrementalPaymentColumns.includes(col.originalName.toLowerCase())) { // remove card specific incremental payment columns if card generic incremental payment column is mapped
              let isGenericIncPaymentMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'genericIncrementalPayment')
              if (isGenericIncPaymentMatched.length > 0) {
                return
              }
            }

            return (
              <div className="match-row d-flex justify-content-between flex-column flex-md-row" key={col.originalName + index}>
                <div className="table">
                  {
                    showHeader && (
                      <div className="table-header table-row">
                        <div className="no table-col">
                          {alphas[index]}
                        </div>
                        <div className="table-col flex-column flex-md-row">
                          <span className="col-value align-self-stretch align-self-md-center">{col.originalName}</span>
                          <div className="col-selector align-self-stretch">
                            <Select
                              options={columnOptions?.filter(columnOption => colWithStatus.findIndex((colWith, index) => {
                                if (columnOption.value === 'autoCreateMaster' && currentDomain?.roleId !== 3 && currentDomain?.roleName !== 'admin' && currentDomain?.roleId !== 2 && currentDomain?.roleName !== 'moderator') {
                                  return 1
                                }

                                if (columnOption.value === 'cardPaymentByPhoneValue') {
                                  let confirmVal = colWithStatus.find(colwith => colwith.matchedName === "isAcceptCardPaymentByPhone")
                                  if (!confirmVal || confirmVal.confirm !== 2) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'cardPaymentByFaxValue') {
                                  let confirmVal = colWithStatus.find(colwith => colwith.matchedName === "isAcceptCardPaymentByFax")
                                  if (!confirmVal || confirmVal.confirm !== 2) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'cardEmail') {
                                  let confirmVal = colWithStatus.find(colwith => colwith.matchedName === "isAcceptCardPaymentByEmail")
                                  if (!confirmVal || confirmVal.confirm !== 2) {
                                    return 1
                                  }
                                }

                                if (!showManualParsedAddress && addressColumns.includes(columnOption.value)) { // remove address columns if full address is mapped
                                  let isFullAddMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'fullAddress')
                                  if (isFullAddMatched.length > 0) {
                                    return 1
                                  }
                                }

                                if (!showManualParsedAddress && columnOption.value === 'fullAddress') { // remove full address column if any of address column is mapped
                                  let matchedAddressColumns = colWithStatus.filter((column) => column.confirm === 2 && addressColumns.includes(column.matchedName))
                                  if (matchedAddressColumns.length > 0) {
                                    return 1
                                  }
                                }

                                if (cardVariableFeeCols.includes(columnOption.value)) { // remove card specific variable fee columns if card generic variable fee is mapped
                                  let isGenericVariableFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'isAcceptVariableFee')
                                  if (isGenericVariableFeeMatched.length > 0) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'isAcceptVariableFee') { // remove generic variable fee column if any of card specific variable fee column is mapped
                                  let matchedCardVariableFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && cardVariableFeeCols.includes(column.matchedName))
                                  if (matchedCardVariableFeeColumns.length > 0) {
                                    return 1
                                  }
                                }

                                if (cardProcessingFeeCols.includes(columnOption.value)) { // remove card specific processing fee columns if card generic processing fee is mapped
                                  let isGenericProcessingFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && (column.matchedName === 'genericDollarProcessingFee' || column.matchedName === 'genericPercentProcessingFee'))
                                  if (isGenericProcessingFeeMatched.length > 0) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'genericDollarProcessingFee' || columnOption.value === 'genericPercentProcessingFee') { // remove generic processing fee column if any of card specific processing fee column is mapped
                                  let matchedCardProcessingFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && cardProcessingFeeCols.includes(column.matchedName))
                                  if (matchedCardProcessingFeeColumns.length > 0) {
                                    return 1
                                  }
                                }

                                if (cardMinFeeCols.includes(columnOption.value)) { // remove card specific min fee columns if card generic min fee is mapped
                                  let isGenericMinFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && (column.matchedName === 'genericDollarMinFee' || column.matchedName === 'genericPercentMinFee'))
                                  if (isGenericMinFeeMatched.length > 0) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'genericDollarMinFee' || columnOption.value === 'genericPercentMinFee') { // remove generic min fee column if any of card specific min fee column is mapped
                                  let matchedCardMinFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && cardMinFeeCols.includes(column.matchedName))
                                  if (matchedCardMinFeeColumns.length > 0) {
                                    return 1
                                  }
                                }

                                if (cardMaxFeeCols.includes(columnOption.value)) { // remove card specific max fee columns if card generic max fee is mapped
                                  let isGenericMaxFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && (column.matchedName === 'genericDollarMaxFee' || column.matchedName === 'genericPercentMaxFee'))
                                  if (isGenericMaxFeeMatched.length > 0) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'genericDollarMaxFee' || columnOption.value === 'genericPercentMaxFee') { // remove generic max fee column if any of card specific max fee column is mapped
                                  let matchedCardMaxFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && cardMaxFeeCols.includes(column.matchedName))
                                  if (matchedCardMaxFeeColumns.length > 0) {
                                    return 1
                                  }
                                }

                                if (cardIncrementalFeeCols.includes(columnOption.value)) { // remove card specific incremental fee columns if card generic incremental fee is mapped
                                  let isGenericIncrementalFeeMatched = colWithStatus.filter((column) => column.confirm === 2 && (column.matchedName === 'genericDollarIncrementalFee' || column.matchedName === 'genericPercentIncrementalFee'))
                                  if (isGenericIncrementalFeeMatched.length > 0) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'genericDollarIncrementalFee' || columnOption.value === 'genericPercentIncrementalFee') { // remove generic incremental fee column if any of card specific incremental fee column is mapped
                                  let matchedCardIncrementalFeeColumns = colWithStatus.filter((column) => column.confirm === 2 && cardIncrementalFeeCols.includes(column.matchedName))
                                  if (matchedCardIncrementalFeeColumns.length > 0) {
                                    return 1
                                  }
                                }

                                if (cardMinPaymentColumns.includes(columnOption.value)) { // remove card specific min payment columns if card generic min payment column is mapped
                                  let isGenericMinPaymentMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'genericMinPayment')
                                  if (isGenericMinPaymentMatched.length > 0) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'genericMinPayment') { // remove generic min payment column if any of card specific min payment columns is mapped
                                  let matchedCardMinPaymentColumns = colWithStatus.filter((column) => column.confirm === 2 && cardMinPaymentColumns.includes(column.matchedName))
                                  if (matchedCardMinPaymentColumns.length > 0) {
                                    return 1
                                  }
                                }

                                if (cardMaxPaymentColumns.includes(columnOption.value)) { // remove card specific max payment columns if card generic max payment column is mapped
                                  let isGenericMaxPaymentMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'genericMaxPayment')
                                  if (isGenericMaxPaymentMatched.length > 0) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'genericMaxPayment') { // remove generic max payment column if any of card specific max payment columns is mapped
                                  let matchedCardMaxPaymentColumns = colWithStatus.filter((column) => column.confirm === 2 && cardMaxPaymentColumns.includes(column.matchedName))
                                  if (matchedCardMaxPaymentColumns.length > 0) {
                                    return 1
                                  }
                                }

                                if (cardIncrementalPaymentColumns.includes(columnOption.value)) { // remove card specific max payment columns if card generic max payment column is mapped
                                  let isGenericIncPaymentMatched = colWithStatus.filter((column) => column.confirm === 2 && column.matchedName === 'genericIncrementalPayment')
                                  if (isGenericIncPaymentMatched.length > 0) {
                                    return 1
                                  }
                                }

                                if (columnOption.value === 'genericIncrementalPayment') { // remove generic max payment column if any of card specific max payment columns is mapped
                                  let matchedCardIncPaymentColumns = colWithStatus.filter((column) => column.confirm === 2 && cardIncrementalPaymentColumns.includes(column.matchedName))
                                  if (matchedCardIncPaymentColumns.length > 0) {
                                    return 1
                                  }
                                }

                                return colWith.matchedName === columnOption.value && colWith.confirm === 2
                              }
                              ) === -1)}
                              value={getSuggestedSelectValue(col)}
                              onChange={(val) => {
                                handleChangeRealCol(val, col)
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  }
                  <div className={`table-body ${!showHeader ? 'noHeader' : ''}`}>
                    {
                      tableData.map((row, ind) => {
                        if (ind < 4) {
                          return (
                            <div className="table-row" key={`matchedrow${col.originalName}` + ind}>
                              <div className="no table-col">
                                {ind + 1}
                              </div>
                              <div className="table-col">
                                {/* {row[col.originalName]} */}
                                {col.matchedName === "contactDate" ? watchCell(col.matchedName, row[col.originalName]) : row[col.originalName]}
                                {/* {watchCell(col.matchedName, row[col.originalName])} */}
                              </div>
                            </div>
                          )
                        } else if (ind === 4) {
                          return (
                            <div className="table-row" key={`matchedrow${col.originalName}` + ind}>
                              <div className="no table-col">
                                {ind + 1}
                              </div>
                              <div className="table-col">
                                ...
                              </div>
                            </div>
                          )
                        } else {
                          return null
                        }
                      })
                    }
                  </div>
                </div>
                <div className="action d-flex flex-column justify-content-center justify-content-lg-between">
                  <div className="result">
                    <span className='h4'>
                      {
                        col.confirm === 2 && (
                          <>
                            <CheckSvg />
                            Matched to the&nbsp;
                            {
                              showHeader && (
                                <strong>{col.matchedName}</strong>
                              )
                            }
                          </>
                        )
                      }
                      {
                        col.confirm === 0 && (
                          <>
                            Ignored&nbsp;
                          </>
                        )
                      }
                      {
                        !showHeader && (
                          <div className="col-selector">
                            <Select
                              options={columnOptions?.filter(columnOption => colWithStatus.findIndex(colWith => {
                                if (columnOption.value === 'autoCreateMaster' && currentDomain?.roleId !== 3 && currentDomain?.roleName !== 'admin' && currentDomain?.roleId !== 2 && currentDomain?.roleName !== 'moderator') {
                                  return 1
                                }
                                return colWith.matchedName === columnOption.value && colWith.confirm !== 2
                              }
                              ) === -1)}
                              value={getSuggestedSelectValue(col)}
                              onChange={val => handleChangeRealCol(val, col)}
                            />
                          </div>
                        )
                      }
                    </span>
                  </div>
                  <div className="buttons gap-3 d-flex align-items-center justify-content-between flex-column flex-lg-row">
                    <button
                      type="button"
                      className={`btn confirm ${col.confirm === 2 ? 'selected text-white' : 'btn-green'}`}
                      onClick={() => { handleClickConfirm(col) }}
                    >
                      {col.confirm === 2 ? 'Confirmed' : 'Confirm Mapping'}
                    </button>
                    <button
                      type="button"
                      className={`btn btn-white ignore ${col.confirm === 0 ? 'selected' : ''}`}
                      onClick={() => { handleClickIgnore(col) }}
                    >
                      {col.confirm === 0 ? 'Ignored' : 'Ignore this column'}
                    </button>
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>

    )
  }

  const handleShowModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleSetSpendDuration = (timeFrame, timeType) => {
    dispatch(
      setSpendDuration({
        spendTimeFrame: timeFrame,
        spendTimeType: timeType,
      })
    )
    setShowModal(false)
  }

  const alphas = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

  useEffect(() => {
    if (!uploadedData || !uploadedData.cols || uploadedData.cols.length === 0) {
      return
    }
    setColWithStatus(uploadedData.cols.map((item, index) => (
      {
        originalName: item,
        matchedName: getSuggestedValueFromOriginalName(item),
        confirm: 1,
      }
    )))
    onCallWithStatus(uploadedData.cols.map((item, index) => (
      {
        originalName: item,
        matchedName: getSuggestedValueFromOriginalName(item),
        confirm: 1,
      }
    )))
    // eslint-disable-next-line
  }, [uploadedData])

  useEffect(() => {
    if (matchedData && matchedData.cols && matchedData.cols.length > 0) {
      setColWithStatus(matchedData.cols)
      onCallWithStatus(matchedData.cols)
    }
  }, [matchedData, uploadAllVendorColumns])

  // set address columns values when Full Address will mapped
  const setAddresColumnsValues = async (row, colWithStatus, add1 = '', add2 = '', city = '', state = '', country = '', zip = '') => {
    let isAddress1 = colWithStatus.find((column) => column.matchedName === 'address1')
    let isAddress2 = colWithStatus.find((column) => column.matchedName === 'address2')
    let isCity = colWithStatus.find((column) => column.matchedName === 'city')
    let isState = colWithStatus.find((column) => column.matchedName === 'state')
    let isCountry = colWithStatus.find((column) => column.matchedName === 'country')
    let isZip = colWithStatus.find((column) => column.matchedName === 'zip')
    if (isAddress1) {
      row[isAddress1.originalName] = add1
    } else {
      row['Address1'] = add1
    }
    if (isAddress2) {
      row[isAddress2.originalName] = add2
    } else {
      row['Address2'] = add2
    }
    if (isCity) {
      row[isCity.originalName] = city ? city?.value : ''
    } else {
      row['City'] = city ? city?.value : ''
    }
    if (isState) {
      row[isState.originalName] = state ? state?.value : ''
    } else {
      row['State'] = state ? state?.value : ''
    }
    if (isCountry) {
      row[isCountry.originalName] = country ? country?.value : ''
    } else {
      row['Country'] = country ? country?.value : ''
    }
    if (isZip) {
      row[isZip.originalName] = zip ? zip?.value : ''
    } else {
      row['Zip'] = zip ? zip?.value : ''
    }
  }

  // handle Not Prased Address Screen Continue button Click
  const handleContinue = async (filename = '') => {
    if (!filename || filename === '') { // if all addresses are edited on screen
      notParsedAddressData.map((value) => {
        delete value.changed
        delete value.id
        delete value.edited
        delete value['Full address that can not be parsed']
        uploadedData.cols.map((col) => {
          if (!(col in value)) {
            value[col] = ''
          }
        })
      })
      uploadedData['data'] = [...uploadedData.data, ...notParsedAddressData];
      uploadedData['data'] = [...new Set([...uploadedData['data']])];
      dispatch(
        matchUploadedData(colWithStatus)
      )
      isTest ? onContinue('settings') : onContinue('preview')
    } else { // if import fixed addresses excel file
      const editAddressArray = notParsedAddressData.filter(data => data.edited) // get if any address is edited on the screen
      if (editAddressArray.length > 0) {
        editAddressArray.map(data => { // manually edited data
          delete data.changed
          delete data.id
          delete data.edited
          delete data['Full address that can not be parsed']
          uploadedData.cols.map((col) => {
            if (!(col in data)) {
              data[col] = ''
            }
          })
        })
        uploadedData['data'] = [...uploadedData.data, ...editAddressArray]; // merge manually parsed address data with uploaded data
      }

      // merge imported file data with uploaded data
      importedNotParsedAddressData.map(data => { // imported data from file
        delete data.changed
        delete data.id
        delete data.validated
        delete data.edited
        delete data['Full address that can not be parsed']
        uploadedData.cols.map((col) => {
          if (!(col in data)) {
            data[col] = ''
          }
        })
      })

      uploadedData['data'] = [...uploadedData.data, ...importedNotParsedAddressData]; // merge imported data with uploaded data
      uploadedData['data'] = [...new Set([...uploadedData['data']])];

      colWithStatus.map((col) => {
        if (addressColumns.includes(col.matchedName)) {
          col.confirm = 1 // set address columns not mapped
        }
      })
      dispatch(
        matchUploadedData(colWithStatus)
      )
      setShowManualParsedAddress(true)
      setShowNonParsedAddress(false)
    }
  }

  const handleSelectFile = async (tableData) => {
    setImportedNotParsedAddressData(tableData)
  }

  const onChangePartnerName = (colName, value) => {
    onChangeDbMatchValues(colName, value)
    if (colName === 'partnerName') {
      let contactNames = partnerNames.find(partner => partner?.partnerName === value)?.lists
      contactNames.push({ primaryContact: partnerNames.find(partner => partner?.partnerName === value)?.contactName })
      var uniqueContactNames = Array.from(new Set(contactNames.map(JSON?.stringify))).map(JSON?.parse);
      let callingScripts = partnerNames.find(partner => partner?.partnerName === value)?.callingScripts
      if (callingScripts?.length > 0) {
        setCallingScriptsList(callingScripts)
      } else {
        setCallingScriptsList([])
      }
      setPrimaryContactsList(uniqueContactNames)
    }
  }

  const onChangeCompany = (e) => {
    setCompanyName(e)

    if (e.__isNew__) {
      setModal(false)
      setDbmatchValues(prevState => {
        return {
          ...prevState,
          companyName: { label: e.label, value: null, name: e.label },
          contactPhone: "",
          contactEmail: "",
          nameUse: null,
          listId: null
        }
      })
    } else {
      setModal(true)
      setDbmatchValues(prevState => {
        return {
          ...prevState,
          companyName: "",
          contactPhone: "",
          contactEmail: "",
          nameUse: null,
          listId: null
        }
      })
    }
  }

  const onConfirm = (value) => {
    setModal(false)
    if (value === 'add') {
      let scriptId = companyName?.callingScriptId
      let getCallingScript = allCallingScriptsList.filter(script => script.id === scriptId)
      setDbmatchValues(prevState => {
        return {
          ...prevState,
          callingScriptId: scriptId ? { label: getCallingScript[0]?.title, value: getCallingScript[0]?.id } : null,
          companyName: { label: companyName?.label.trim(), value: companyName?.value, name: companyName?.name },
          contactPhone: companyName?.contactPhone,
          contactEmail: companyName?.contactEmail,
          nameUse: companyName?.nameUse,
          primaryContact: companyName?.primaryContact,
          listId: companyName?.listId
        }
      })
      let isScriptExist = callingScriptsList.find(script => script.id === getCallingScript[0]?.id)
      if (!isScriptExist) {
        let tmp = { id: getCallingScript[0]?.id, title: getCallingScript[0]?.title, isDefault: false }
        let tmpList = [...callingScriptsList, tmp]
        setCallingScriptsList(tmpList)
      }
    } else {
      let selectedPartnerName = dbMatchDataValues?.partnerName
      let contactName = partnerNames.find((value) => value?.partnerName === selectedPartnerName)?.contactName
      let callingScripts = partnerNames?.find(val => val?.partnerName === selectedPartnerName)?.callingScripts
      let defaultScript = callingScripts?.find(script => script?.isDefault)
      setDbmatchValues(prevState => {
        return {
          ...prevState,
          companyName: { label: companyName?.label.trim(), value: companyName?.value, name: companyName?.name },
          contactPhone: "",
          contactEmail: "",
          nameUse: null,
          listId: null,
          primaryContact: contactName,
          callingScriptId: { label: defaultScript?.title, value: defaultScript?.id }
        }
      })
    }
  }

  const onFocusHandler = (colName) => {
    if (colName === 'partnerName' || colName === 'callingScriptId') {
      setZindex(prevState => { return { ...prevState, partnerName: 10, companyName: 9 } })
    } else if (colName === 'companyName') {
      setZindex(prevState => { return { ...prevState, partnerName: 9, companyName: 10 } })
    }
  }

  const handleBulkUpdateClickContinue = () => {
    const allData = uploadedData?.data
    const hasSupplierId = allData?.every(value => value?.hasOwnProperty('supplierId'))
    if (uploadFileType === 'bulkUpdate' && supplierType !== 'child') {
      const requiredKeys = Object.keys(validationFields);
      const notIncluded = requiredKeys?.filter(col => !uploadedData.cols?.includes(col))
      if (notIncluded && notIncluded?.length) {
        let message = notIncluded?.join(', ')
        toast.show({
          title: 'Danger',
          description: `Missing Column Name: "${message}" In your file.`,
        })
        return
      }
    }
    if (!updateSupplierType) {
      toast.show({
        title: 'Warning',
        description: 'Please select supplier type to bulk update!',
      })
      return
    }
    // if (!hasSupplierId) {
    //   toast.show({
    //     title: 'Warning',
    //     description: 'There is no Supplier Id column in uploaded file!',
    //   })
    //   return
    // }
    onContinue('preview')
  }

  const handleSupplierTypeChange = (item) => {
    const dataSourceValue = { ...currentDataSource }
    let tmpColWithStatus = []
    setSelectedSupplierType(item.value)
    setSelectedSupplierOption(item)
    setSupplierType(item.value)
    if (item.value === "master") {
      const keys = Object.keys(bulkUpdateMasterColumnsValues);
      const tmpCols = keys.filter(key => uploadedData?.cols?.includes(key)).map(key => bulkUpdateMasterColumnsValues[key]);
      const namesArray = Object.entries(tmpCols).map(([key, value]) => ({
        ...value
      }));
      for (const [key, value] of Object.entries(bulkUpdateMasterColumnsValues)) {
        tmpColWithStatus.push({
          originalName: key,
          matchedName: value.name,
          confirm: 2,
        });
      }
      dataSourceValue.columns = namesArray
    } else if (item.value === "child") {
      const keys = Object.keys(bulkUpdateChildColumnsValues);
      const tmpCols = keys.filter(key => uploadedData?.cols?.includes(key)).map(key => bulkUpdateChildColumnsValues[key]);
      const namesArray = Object.entries(tmpCols).map(([key, value]) => ({
        ...value
      }));
      for (const [key, value] of Object.entries(bulkUpdateChildColumnsValues)) {
        tmpColWithStatus.push({
          originalName: key,
          matchedName: value.name,
          confirm: 2,
        });
      }
      dataSourceValue.columns = namesArray
    }
    setColWithStatus(tmpColWithStatus)
    onCallWithStatus(tmpColWithStatus)
    dispatch(
      matchUploadedData(tmpColWithStatus)
    )
    handleChangeDataSource(dataSourceValue)
    setUpdateSupplierType(item);

  }

  return (
    <>
      <ModalComponent
        backdrop={backdrop}
        open={modal}
        handleClose={onHandleCloseModal}
        modalTitle={`Existing list import confirmation`}
        size={`md`}
      >
        <h3>Do you want to import into the existing list or create new list?</h3>
        <div className='w-50  d-flex column-gap-3 mt-3 justify-content-center'>
          <button className='report_button_secondary' style={{ width: 150 }} onClick={() => { onConfirm('add') }} >Add Into Existing</button>
          <button className='report_heading_buttons report_button_success' style={{ width: 150 }} onClick={() => { onConfirm('new') }} >Create New</button>
        </div>
      </ModalComponent>
      {showNonParsedAddress ?
        <NotParsedAddressTable
          tableData={notParsedAddressData}
          columns={notParsedAddressColumns}
          onHandleContinue={handleContinue}
          onGoBack={() => setShowNonParsedAddress(false)}
          onSelectFile={handleSelectFile}
        />
        :
        <>
          {isParsingFullAddress && <><h3 className='loader-message'>Parsing Full Address</h3><LoaderComponent /></>}
          {isLoading && <LoaderComponent />}
          <div className={`match-tab ${isParsingFullAddress && 'loading'}`}>
            <div className="match-header">
              {currentDataSource?.value !== 'bulkUpdate' && (
                <div className="header-option">
                  <h3 className='fw-bold'>Contain Headers</h3>
                  <ToggleButton
                    onChange={(checked) => setShowHeader(checked)}
                    checked={showHeader}
                  />
                </div>
              )}
              <div className="header-datasource flex-wrap d-flex align-items-center justify-content-start flex-sm-nowrap">
                <h3 className='fw-bold'>DATA SOURCE:*</h3>
                <div className="source-selector">
                  <Select
                    className="h4"
                    options={dataSourceOptions}
                    value={currentDataSource}
                    onChange={val => handleChangeDataSource(val)}
                  />
                </div>
              </div>
              <div className='d-flex flex-column gap-4 mt-4 mb-5'>
                {(currentDataSource?.value === "list") && dbMatchColumns.map(col => {
                  return (
                    <div className='d-flex align-items-center'>
                      <h4 className='w-25 text-black mb-0'>{col.label}</h4>
                      {col.name === 'contactPhone' ?
                        <div className=" w-100 d-flex align-items-center gap-2">
                          <div className='d- border rounded phone-input-ext-container w-100 flex-column flex-lg-row w-100'>
                            <ReactPhoneInput
                              className='phone-input-parent w-100'
                              country={'us'}
                              value={dbMatchDataValues[col.name] || ''}
                              onChange={onPhoneInputChange}
                              onBlur={(event, country) => { onPhoneNumberFocusOut(event, country, dbMatchDataValues[col.name]) }}
                              countryCodeEditable={false}
                              preferredCountries={['us']}
                              onKeyDown={(e) => onKeyDown(e, phoneInputRefname)}
                              ref={phoneInputRefname}
                              buttonClass=' border-end border-dark'
                              inputProps={{
                                className: 'border-dark form-control shadow-none'
                              }}
                              disabled={!dbMatchDataValues?.partnerName}
                            />
                          </div>
                          {isValidatingPhone && (<Loader />)}
                          {dbMatchDataValues[col.name] && !isValidatingPhone && isPhoneValid !== '' &&
                            (isPhoneValid ?
                              <BsCheckSquare color="#067911" size={26} />
                              :
                              <BsXSquare color="#f75a52" size={26} />
                            )
                          }
                        </div>
                        :
                        col.name === 'contactEmail' ?
                          <div className="w-100 d-flex gap-2 align-items-center">
                            <input
                              className={`w-100 h4 mb-0 search-input border-dark`}
                              type="text"
                              value={dbMatchDataValues[col.name] || ''}
                              onChange={e => onChangeDbMatchValues(col.name, e.target.value)}
                              onBlur={() => { onEmailFocusOut(dbMatchDataValues[col.name]) }}
                              disabled={!dbMatchDataValues?.partnerName}

                            />
                            {isValidatingEmail && (<Loader />)}
                            {dbMatchDataValues[col.name] && !isValidatingEmail && isEmailValid !== '' &&
                              (isEmailValid ?
                                <BsCheckSquare color="#067911" size={26} />
                                :
                                <BsXSquare color="#f75a52" size={26} />
                              )
                            }
                          </div>
                          :
                          (col.name === 'partnerName' || col.name === 'callingScriptId') ?
                            <div className='d-flex gap-3 w-100'>
                              <Select
                                styles={{
                                  container: (baseStyles) => ({
                                    ...baseStyles,
                                    zIndex: zIndex.partnerName
                                  })
                                }}
                                onFocus={() => { onFocusHandler(col.name) }}
                                menuPortalTarget={document.getElementById("match-header")}
                                menuPosition={'fixed'}
                                className="h4 w-100"
                                classNamePrefix='react-select-selector'
                                options={col.name === 'partnerName' ? partnerNames?.map((partner) => (
                                  {
                                    label: partner?.partnerName,
                                    value: partner?.partnerName
                                  }
                                )) : callingScriptsList?.map((script) => (
                                  {
                                    label: script?.title,
                                    value: script?.id
                                  }
                                ))}
                                value={dbMatchDataValues?.[col.name] ? col.name === 'partnerName' ? {
                                  label: dbMatchDataValues?.[col.name],
                                  value: dbMatchDataValues?.[col.name]
                                } : dbMatchDataValues?.[col.name] : null}
                                onChange={(item) => { onChangePartnerName(col.name, col.name === 'partnerName' ? item?.value : item) }}
                                isDisabled={(col.name === 'callingScriptId' && !dbMatchDataValues?.partnerName) && true}

                              />
                              {isAdminOrModerator && (
                                <button className='show-option-btn' onClick={() => { col.name === 'partnerName' ? onShowPartnerManagement(true) : onShowCreateCallingScript(true) }}> + </button>
                              )}
                            </div>
                            :
                            col.name === 'primaryContact' ?
                              <div className='d-flex gap-3 w-100'>
                                <input
                                  className='search-input h4 mb-0 border-dark'
                                  type='text'
                                  value={dbMatchDataValues?.[col.name] || ''}
                                  onChange={e => onChangeDbMatchValues(col.name, e.target.value)}
                                  list='contactNames'
                                  disabled={!dbMatchDataValues?.partnerName}
                                />
                                <datalist id='contactNames'>
                                  {primaryContactsList.length && primaryContactsList.map((contact) => (
                                    <option value={contact?.primaryContact}>{contact?.primaryContact}</option>
                                  ))}
                                </datalist>
                              </div>
                              :
                              col.name === 'nameUse' ?
                                <div className=" w-100 d-flex align-items-center gap-2">
                                  <ThreeStateToggleButton onChange={(checked) => { onChangeDbMatchValues(col.name, checked) }} checked={dbMatchDataValues?.[col.name]} isDisabled={!dbMatchDataValues?.partnerName} />
                                </div>
                                :
                                col.name === 'companyName' ?
                                  <div className='d-flex gap-3 w-100'>
                                    <CreatableSelect
                                      styles={{
                                        container: (baseStyles) => ({
                                          ...baseStyles,
                                          zIndex: zIndex.companyName,
                                        })
                                      }}
                                      onFocus={() => { onFocusHandler(col.name) }}
                                      className="h4 w-100 h-100"
                                      classNamePrefix='react-select-selector'
                                      value={{
                                        label: dbMatchDataValues?.[col.name]?.label,
                                        value: dbMatchDataValues?.[col.name]?.value
                                      }}
                                      onChange={(e) => { onChangeCompany(e) }}
                                      options={[
                                        { header: true, label: 'Header', listId: 'Header', isDisabled: true },
                                        ...companyList
                                      ]}
                                      // options={companyList}
                                      components={{ Option: CustomOption }}
                                      menuPortalTarget={document.getElementById("match-header")}
                                      menuPosition={'fixed'}
                                      isDisabled={!dbMatchDataValues?.partnerName}
                                    />
                                  </div>
                                  :
                                  <input
                                    className='search-input h4 mb-0 border-dark'
                                    type='text'
                                    value={dbMatchDataValues?.[col.name] || ''}
                                    onChange={e => onChangeDbMatchValues(col.name, e.target.value)}
                                  />
                      }
                    </div>
                  )
                })}
                {(isAdmin || user?.isBulkUpdate) && (currentDataSource?.value === "bulkUpdate") && (
                  <div className='d-flex align-items-center'>
                    <h4 className='w-25 text-black mb-0'>Supplier Type</h4>
                    <Select
                      styles={{
                        container: (baseStyles) => ({
                          ...baseStyles,
                          zIndex: zIndex.partnerName
                        })
                      }}
                      menuPortalTarget={document.getElementById("match-header")}
                      menuPosition={'fixed'}
                      className="h4 w-100"
                      classNamePrefix='react-select-selector'
                      options={[
                        {
                          label: 'Master Supplier',
                          value: 'master'
                        },
                        {
                          label: 'Child Supplier',
                          value: 'child'
                        }
                      ]}
                      value={updateSupplierType}
                      // onChange={(item) => { setUpdateSupplierType(item) }}
                      onChange={(item) => { handleSupplierTypeChange(item) }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="match-tab-action mt-3 mb-5">
              <button type="button" className="btn btn-white back" onClick={() => { onGoBack('upload') }}>
                Go Back
              </button>
              {isValidatingPhone || isValidatingEmail ? (
                <button
                  type="button"
                  className="btn btn-black continue"
                >
                  Validating...
                </button>
              )
                :
                <button type="button" className="btn btn-black continue" onClick={currentDataSource?.value === "bulkUpdate" ? handleBulkUpdateClickContinue : handleClickContinue}>
                  Continue
                </button>
              }
            </div>
            {currentDataSource?.value !== 'bulkUpdate' && (
              matchContents()
            )}

            {currentDataSource?.value !== 'bulkUpdate' && currentDataSource !== null ? <div className="match-tab-action mt-3 mb-5">
              <button type="button" className="btn btn-white back" onClick={() => { onGoBack('upload') }}>
                Go Back
              </button>
              {isValidatingPhone || isValidatingEmail ? (
                <button
                  type="button"
                  className="btn btn-black continue"
                >
                  Validating...
                </button>
              )
                :
                <button type="button" className="btn btn-black continue" onClick={currentDataSource?.value === "bulkUpdate" ? handleBulkUpdateClickContinue : handleClickContinue}>
                  Continue
                </button>
              }
            </div> : null}
            <SpendInfoModal
              onClose={handleCloseModal}
              show={showModal}
              spendTimeFrame={spendTimeFrame}
              spendTimeType={spendTimeType}
              onUpload={handleSetSpendDuration}
            />
          </div>
        </>
      }

    </>
  )
}

export default MatchComponent
